module.exports = __webpack_public_path__ + "static/media/badge-check.6e5c75ee.svg";